import { render, staticRenderFns } from "./MusicPlayer.vue?vue&type=template&id=0f48343e&scoped=true"
import script from "./MusicPlayer.vue?vue&type=script&lang=js"
export * from "./MusicPlayer.vue?vue&type=script&lang=js"
import style0 from "./MusicPlayer.vue?vue&type=style&index=0&id=0f48343e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f48343e",
  null
  
)

export default component.exports